module.exports = __webpack_public_path__ + "static/media/cta-arrow-next-green.daec1393.svg";